import { Element, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, ReferenceTableElement } from 'slate/types/slate';
import { StyledDataSheet } from 'app/components';

export const isReferenceTable = (node: Node): node is ReferenceTableElement => Element.isElement(node) && node.type === 'reference-table';

const withReferenceTable =
  (_options: Record<string, unknown> = {}) =>
  (editor: CustomEditor) => {
    const { renderElement, isVoid } = editor;
    editor.isVoid = (element: CustomElement) => isReferenceTable(element) || isVoid(element);

    editor.renderElement = (props: RenderElementProps) => {
      if (isReferenceTable(props.element)) {
        return <StyledDataSheet {...props} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default withReferenceTable;
